module.exports = __webpack_public_path__ + "static/media/VectorArrowRight.6dd11e0c.svg";